import { Model, table, index, primary, field } from '@tencent/memoire-structured-storage';
import { SnapshotFormat } from '../definitions';
import { JSONSnapshotData, RawObjectSnapshotData, ZlibSnapshotData } from '../snapshot-data';
import type { SnapshotMeta, SerializedData, SnapshotData } from '../definitions';

@table('SnapshotDataItems')
export class SnapshotDataItemsModel extends Model {
    public static fromSerializedData(meta: SnapshotMeta, { data, format }: SerializedData<unknown>) {
        return new this({
            ...meta,
            data,
            format,
        });
    }

    @primary()
    public id: string;

    @index()
    public globalPadId: string;

    @index()
    public userId: string;

    @field()
    public data: unknown;

    @field()
    public format: SnapshotFormat;

    public constructor({
        id,
        globalPadId,
        userId,
        data,
        format,
    }: {
        id: string;
        globalPadId: string;
        userId: string;
        data: unknown;
        format: SnapshotFormat;
    }) {
        super();

        this.id = id;
        this.globalPadId = globalPadId;
        this.userId = userId;
        this.data = data;
        this.format = format;
    }

    // 获取快照内容，解码为对象格式
    public async getPayload<PayloadType>(): Promise<PayloadType> {
        const data = await this.toSnapshotData<PayloadType>();
        return data.getPayload();
    }

    private toSnapshotData<PayloadType>(): Promise<SnapshotData<PayloadType, unknown>> {
        if (this.format === SnapshotFormat.JSON) {
            return JSONSnapshotData.fromSerializedData<PayloadType>(this.data as string);
        }

        if (this.format === SnapshotFormat.Zlib) {
            return ZlibSnapshotData.fromSerializedData<PayloadType>(this.data as Uint8Array);
        }

        return RawObjectSnapshotData.fromSerializedData<PayloadType>(this.data as PayloadType);
    }
}
